/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  scheduleFor: 'Agendar em nome de',
  scheduleForAssistedUser:
    'Atualize as definições das reuniões em nome de {userName}.',
  scheduleForGuidance:
    'Está a agendar para outra pessoa?\n1. Certifique-se de que se encontra no Calendário do Outlook dessa pessoa.\n2. No menu pendente, selecione a pessoa para a qual está a agendar.\n',
  scheduleForGuidanceMore: 'Obter detalhes',
  meetingSettings: 'Definições da reunião',
  meetingSettingsDescription:
    'As atualizações serão aplicadas apenas a esta reunião.',
  [ASSISTED_USERS_MYSELF]: 'Eu',
  waitingRoomTitle: 'Utilizar sala de espera',
  waitingRoomDescription:
    'Os participantes aguardam até que os admita. Ideal para entrevistas ou participantes externos.',
  waitingRoomNotCoworker: 'Para qualquer pessoa fora da minha empresa',
  waitingRoomGuest: 'Para qualquer pessoa sem sessão iniciada',
  waitingRoomAll: 'Para todos os participantes',
  enterPassword: 'Introduzir palavra-passe',
  onlyJoinAfterMe: 'Iniciar reunião após a sua entrada',
  allowJoinBeforeHostDescription:
    'A reunião começará depois de entrar para evitar conversas antecipadas.',
  requirePassword: 'Exigir palavra-passe',
  requirePasswordDescription:
    'Mantenha a sua reunião segura. Não será solicitada uma palavra-passe às pessoas que utilizem a ligação.',
  password: 'Palavra-passe:',
  passwordEmptyError: 'Palavra-passe da reunião obrigatória',
  passwordInvalidError:
    'A palavra-passe deve ter 1 a 10 letras e números, mas não pode conter símbolos',
  passwordHintText:
    'A palavra-passe deve ter 1 a 10 letras e números, mas não pode conter símbolos.',
  usePersonalMeetingIdInstead: 'Utilizar ligação da reunião pessoal',
  allowMeetingAccess: 'Gerir quem pode entrar',
  anyoneWithLink: 'Qualquer pessoa com a ligação',
  signedInUsers: 'Apenas contas {shortName}',
  signedInCoWorkers: 'Apenas os meus colegas',
  passwordLabel: 'Palavra-passe',
  edit: 'Editar',
  editSettings: 'Editar definições',
  lockTooltip: 'Esta definição é gerida pelo administrador da empresa',
  cancel: 'Cancelar',
  update: 'Atualizar',
  pmiSettingsTitle: 'Definições da reunião pessoal',
  pmiSettingsDescription:
    'Defina quem pode entrar e como o pode fazer para a sua ligação da reunião pessoal.',
} as const;

// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"scheduleForAssistedUser"@#@ @source: @#@"Update meetings settings on behalf of {userName}."@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Updates will apply to this meeting only."@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Use waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Participants wait until you admit them. Great for interviews or outside attendees."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"For anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"For anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"For all participants"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Start meeting after you join"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"The meeting will start after you join to prevent early conversations."@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Keep your meeting secure. Anyone using the link won't be prompted for a password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting link"@#@
// @key: @#@"allowMeetingAccess"@#@ @source: @#@"Manage who can join"@#@
// @key: @#@"anyoneWithLink"@#@ @source: @#@"Anyone with link"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Only {shortName} accounts"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Only my coworkers"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"editSettings"@#@ @source: @#@"Edit settings"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"pmiSettingsTitle"@#@ @source: @#@"Personal meeting settings"@#@
// @key: @#@"pmiSettingsDescription"@#@ @source: @#@"Set who can join and how for your personal meeting link."@#@
